// extracted by mini-css-extract-plugin
module.exports = {"root":"_2RJDN","button":"_2j-eU","flipped":"_5mheq"};